import { SavePrivateBillRequestModel } from "./SavePrivateBillRequestModel";

class SaveAndFaxPrivateBillRequestModel extends SavePrivateBillRequestModel {
    public PatientContactId: string;
    public constructor(init?: Partial<SaveAndFaxPrivateBillRequestModel>) {
        super(init);
        Object.assign(this, init);
    }
}

export { SaveAndFaxPrivateBillRequestModel };
